module.exports = __webpack_public_path__ + "static/media/checkitoff-macbook-dashboard.c25abfb5.jpg";